<template>
  <!--团队详情-->
  <a-modal
    title="团队详情"
    style="top: 20px;"
    :width="1200"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleClose"
    @ok="handleSubmit"
    :footer="null"
    :maskClosable="false"
  >
    <div class="table-page-search-wrapper">
      <a-form :form="form" layout="inline" style="margin-left: 0px">
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-button class="twobtn" type="primary" @click="coverage">团队服务区域</a-button>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="团员姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:260px;">
              <a-input v-model="queryParam.userName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:260px;">
              <a-input v-model="queryParam.phone" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="接单方式" style="width:260px;">
              <a-select @change="handleChange" v-model="queryParam.orderType">
                <a-select-option value="自动分单">
                  自动分单
                </a-select-option>
                <a-select-option value="手动分单">
                  手动接单
                </a-select-option>
                <a-select-option value="抢单">
                  抢单
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              label="服务类别"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              style="width:216px;margin-left: 40px;"
            >
              <a-select v-model="queryParam.installType">
                <a-select-option v-for="type in restaurantTypes1" :key="type.label">{{ type.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="6" :sm="24">
            <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:260px;">
              <a-range-picker
                v-model="queryParam2.EndTime"
                :showTime="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                @change="onChange1"
                @ok="onOk"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="合同文件" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:260px;">
              <a-select v-model="queryParam.hasContract">
                <a-select-option value="无">
                  无
                </a-select-option>
                <a-select-option value="有">
                  有
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              label="标签"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              style="width:232px;margin-left: 28px;"
            >
              <a-select v-model="queryParam.label">
                <a-select-option v-for="(type, index) in data5" :key="type.installLabelId">{{
                  type.installLabelName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="近30天投诉率" style="margin-left:10px;" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="queryParam.complaintRateBegin" style="width:60px;margin-left:4px" />
              <span style="margin:0 5px">-</span>
              <a-input v-model="queryParam.complaintRateEnd" style="width: 60px;" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="16"></a-col>
          <a-col :span="8">
            <span style="display: flex;justify-content: center;">
              <a-button class="twobtn" type="primary" htmlType="submit" @click="$refs.table4.refresh(true)"
                >查询</a-button
              >
              <a-button class="twobtn" style="margin-left: 35px" @click="resetDate">清空</a-button>
            </span>
          </a-col>
        </a-row>
        <div style="margin-bottom: 20px">
          <span style="color: deepskyblue;font-size: 20px;">团队信息</span>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="团队名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width:260px;">
                <a-input :disabled="teamShow" v-decorator="['teamName']" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="分单方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select :disabled="teamShow" mode="multiple" v-decorator="['openOrder']" @change="handleChange6">
                  <a-select-option value="0">
                    自动分单
                  </a-select-option>
                  <a-select-option value="1">
                    手动分单
                  </a-select-option>
                  <a-select-option value="2">
                    抢单
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :span="1">
              <a-button
                :disabled="teamShow"
                v-if="show"
                class="twobtn"
                style="margin-top: 10px"
                type="primary"
                @click="Tomap"
                >电子围栏11</a-button
              >
            </a-col> -->
          </a-row>
          <a-row>
            <a-col :md="24" :sm="24">
              <a-form-item label="服务类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-checkbox-group
                  :disabled="teamShow"
                  v-decorator="[
                    'installType.installType',
                    { initialValue: addd },
                    { rules: [{ required: true, message: '请输入服务类别' }] }
                  ]"
                  style="width: 100%;margin-top:5px;"
                  @change="handleCheck11"
                >
                  <a-checkbox v-for="type in restaurantTypes1" :value="type.code">
                    {{ type.label }}
                  </a-checkbox>
                </a-checkbox-group>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-form-item>
                <a-tabs ref="tabPane" @change="callback2" type="card">
                  <a-tab-pane v-for="type in installTabs" :tab="type.label" :key="type.code">
                    <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" class="redItem">
                      <a-checkbox-group
                        :disabled="teamShow"
                        v-decorator="['masterLabelList' + '$' + type.code, { initialValue: getInitalValue(type.code) }]"
                        style="width: 100%;margin-top:5px;"
                        @change="handleCheck2"
                        :key="'masterLabel' + '$' + type.code"
                      >
                        <a-checkbox
                          v-for="item in data4[type.code]"
                          :value="item.installLabelId"
                          :key="type.code + item.installLabelId"
                        >
                          {{ item.installLabelName }}
                        </a-checkbox>
                      </a-checkbox-group>
                    </a-form-item>
                  </a-tab-pane>
                </a-tabs>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" style="margin-top: 80px">
            <a-col :md="12" :sm="24">
              <div style="min-height: 400px; position: relative">
                <div style="width:500px;height:500px;" ref="chart"></div>
                <div id="alert">
                  <a-card :bordered="true" style="width:190px">
                    <p>虚拟得分1:{{ ScoreArr.firstFicScore }}</p>
                    <p>虚拟得分2:{{ ScoreArr.secondFicScore }}</p>
                    <p>虚拟得分透明度1:{{ ScoreArr.firstFicTransparency }}</p>
                    <p>虚拟得分透明度2:{{ ScoreArr.secondFicTransparency }}</p>
                  </a-card>
                </div>
              </div>
            </a-col>
            <a-col :md="6" :sm="24">
              <div style="min-height: 400px;">
                <a-form-item label="得分" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width: 260px;">
                  <a-input :disabled="true" v-decorator="['abilityScore']" />
                </a-form-item>
                <a-table :columns="columns" :pagination="pagination" :data-source="tabeldata" bordered>
                  <template slot="title" slot-scope="currentPageData">
                    接单情况
                  </template>
                </a-table>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              合同文件
              <a-upload
                name="file"
                :multiple="true"
                :action="uploadUrlb"
                :headers="headers"
                :fileList="fileList1"
                @change="uploadChange"
                :beforeUpload="beforeUpload"
                showUploadList="false"
              >
                <a-button class="twobtn" :disabled="teamShow || !deitEnabel" style="margin-left: 10px;" type="primary"
                  >上传</a-button
                >
              </a-upload>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="24" :sm="24" style="margin-bottom: 20px">
              <a-table :dataSource="contractData" :columns="columns3" :pagination="false" size="small">
                <a slot="action3" slot-scope="text, record">
                  <a-checkbox :disabled="teamShow" v-model="record.isMainContract == 0" @change="checkChange(record)">
                    主合同
                  </a-checkbox>
                </a>
                <template slot="name" slot-scope="text, record">
                  <editable-cell :text="text" @change="onCellChange(record, 'name', $event)" :disabled="teamShow" />
                </template>
                <template slot="name2" slot-scope="text, record">
                  <editable-cell2
                    :start="record.contractStartTime"
                    :end="record.contractEndTime"
                    @change="onCellChange2(record, 'name', $event)"
                    :disabled="teamShow"
                  />
                </template>
                <template slot="name3" slot-scope="text, record">
                  <editable-cell3 :text="text" @change="onCellChange3(record, 'name', $event)" :disabled="teamShow" />
                </template>
                <span slot="action2" slot-scope="text, record">
                  <span v-if="contractSelect">
                    <a @click="delsee(record.contractPdfAddress)" :disabled="teamShow">查看</a>
                    <a-divider type="vertical" />
                    <a @click="delByIds(record)" :disabled="teamShow">下载</a>
                  </span>
                  <a-divider v-if="contractSelect && deitEnabel" type="vertical" />
                  <span v-if="deitEnabel">
                    <a v-if="record.disable == 1" @click="showState(record)" :disabled="teamShow">启用</a>
                    <a v-else @click="showState(record)" :disabled="teamShow">禁用</a>
                  </span>
                  <a-divider
                    v-if="(contractDelete && deitEnabel) || (contractDelete && contractSelect)"
                    type="vertical"
                  />
                  <a v-if="contractDelete" @click="delaction(record)" :disabled="teamShow">删除</a>
                </span>
              </a-table>
            </a-col>
          </a-row>
          <a-row :gutter="24" style="margin-bottom: 20px">
            <a-col :md="6" :sm="24">
              <span>
                团员列表
                <!--                  <a-button :disabled="teamShow" class="twobtn" style="margin-left: 10px" v-if="addEnable" icon="plus" type="primary" @click="handleadd()">新增</a-button>-->
              </span>
            </a-col>
          </a-row>
          <s-table
            size="default"
            ref="table4"
            rowKey="modelId"
            :scroll="{ x: 200 }"
            :loading="loading"
            :columns="columns2"
            :data="loadData"
            bordered
          >
            <span slot="action" slot-scope="text, record">
              <a v-if="memberListDetail" @click="handleSee(record)" :disabled="teamShow"
                >查看<a-divider type="vertical"
              /></a>
              <a v-if="memberListDetail" @click="ServiceArea(record)" :disabled="!editEnable || teamShow"
                >服务区域<a-divider type="vertical"
              /></a>
              <span v-if="editEnable">
                <a @click="handleEdit(record)" :disabled="teamShow">编辑<a-divider type="vertical"/></a>
                <a v-if="record.black == 1" @click="showState2(record)" :disabled="teamShow"
                  >启用<a-divider type="vertical"
                /></a>
                <a v-else @click="showState2(record)" :disabled="teamShow">禁用<a-divider type="vertical"/></a>
              </span>
              <a v-if="deleteEnabel" @click="delaction2(record)" :disabled="teamShow">删除</a>
            </span>
          </s-table>
        </div>
      </a-form>
    </div>
    <a-modal
      title="服务区域"
      style="top: 20px;"
      :width="1200"
      v-model="visible3"
      :confirmLoading="confirmLoading"
      @cancel="handleClose1"
      :footer="false"
      :maskClosable="false"
    >
      <a-form>
        <a-form-item style="display: flex;justify-content: flex-end;margin-right: 10%">
          <a-button :disabled="!editEnable" type="primary" icon="plus" @click="addItem1">新增</a-button>
          <a-button :disabled="!editEnable" type="primary" style="margin-left: 8px" @click="delectCoverage()"
            >删除</a-button
          >
        </a-form-item>
      </a-form>
      <a-table
        :loading="loading"
        :columns="columns4"
        :row-selection="{ selectedRowKeys: userAreaIds3, onChange: onSelectChange }"
        :dataSource="coverageData"
        rowKey="userAreaId"
        size="default"
        ref="table2"
        :pagination="false"
        bordered
      >
        <span slot="action" slot-scope="text, record"> </span>
      </a-table>
    </a-modal>
    <a-modal
      title="添加"
      style="top: 20px;"
      :width="800"
      v-model="visible4"
      :confirmLoading="confirmLoading"
      @cancel="handleClose2"
      @ok="handleSubmit02"
      :maskClosable="false"
    >
      <a-form :form="form2">
        <a-form-item label="省份名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-select
            v-decorator="['province', { rules: [{ required: true, message: '请选择省份名称' }] }]"
            @change="haveProvince02"
          >
            <a-select-option v-for="type in data1" :key="type.provinceCode">{{ type.provinceName }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="城市名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-select
            v-decorator="['city', { rules: [{ required: true, message: '请选择城市' }] }]"
            @change="haveProvince03"
          >
            <a-select-option v-for="type in cdata" :key="type.cityCode">{{ type.cityName }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="区域名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-checkbox :checked="checkAll" @change="onChange4($event)">
            全选
          </a-checkbox>
          <br />
          <a-checkbox-group
            v-decorator="['areaList', { rules: [{ required: true, message: '区域名称' }] }]"
            v-for="type in sdata"
            @change="onChange"
          >
            <a-checkbox :value="type.areaCode">
              {{ type.areaName }}
            </a-checkbox>
          </a-checkbox-group>
          <a-alert v-if="warnShow" message="已选择全部区域，无法添加" type="warning" show-icon />
          <!--            <a-select-->
          <!--              mode="multiple"-->
          <!--              v-decorator="['areaList', { rules:[{required: true, message: '区域名称'}]}]"-->
          <!--              -->
          <!--              @change="handChange"-->
          <!--            >-->
          <!--              <a-select-option  v-for="type in sdata" :key="type.areaCode">{{type.areaName}}</a-select-option>-->
          <!--            </a-select>-->

          <!--<a-select v-model="queryParam1.areaId">-->
          <!--<a-select-option  v-for="type in sdata" :key="type.areaCode">{{type.areaName}}</a-select-option>-->
          <!--</a-select>-->
        </a-form-item>
      </a-form>
    </a-modal>
    <a-row :span="24" style="margin-top: 40px" v-if="enterpriseShow != 0">
      <a-affix style="position: fixed; bottom:52px; left: 40%; z-index: 10;">
        <div style="width: 160px;">
          <a-button style="float: left" type="primary" @click="handSubmit" :disabled="teamShow">提交</a-button>
          <a-button style="float: right" @click="getClose">取消</a-button>
        </div>
      </a-affix>
    </a-row>
    <!--<a-affix :offsetBottom="40" style="margin-left:35%;margin-top: 46px;">-->
    <!--<a-button style="margin-right: 100px;width:150px" type="primary" :disabled="teamShow" @click="handSubmit">提交</a-button>-->
    <!--<a-button style="width:150px" @click="getClose">取消</a-button>-->
    <!--</a-affix>-->
    <new-league-members ref="modal" @ok="handleOk"></new-league-members>
    <tomap ref="tomaps"></tomap>
    <member-service ref="modal2"></member-service>
    <a-modal
      title="文件查看"
      style="top: 20px;"
      :width="1000"
      v-model="visible5"
      :confirmLoading="confirmLoading"
      @cancel="handleClose3"
      @ok="handleSubmit02"
      :footer="false"
      :maskClosable="false"
    >
      <div class="pdf" v-show="fileType === 'pdf'">
        <p class="arrow" style="display: flex;justify-content: space-around">
          <a-button @click="changePdfPage(0)" class="turn" :class="{ grey: currentPage == 1 }">上一页</a-button>
          {{ currentPage }} / {{ pageCount }}
          <a-button @click="changePdfPage(1)" class="turn" :class="{ grey: currentPage == pageCount }">下一页</a-button>
        </p>
        <pdf
          :src="src"
          :page="currentPage"
          @num-pages="pageCount = $event"
          @page-loaded="currentPage = $event"
          @loaded="loadPdfHandler"
        >
        </pdf>
      </div>
    </a-modal>
  </a-modal>
</template>

<script>
import pdf from 'vue-pdf'
import { STable } from '@/components'
import { ACCESS_TOKEN } from '@/store/mutation-types'

import Tomap from './Tomap.vue'
// import { LockanRadar } from '@/components'
import { checkPermission } from '@/utils/permissions'
import {
  selectALLInstallLabel,
  selectInstallTypeAndLabel,
  deleteUserArea,
  getelectCityName,
  getelectAreaName,
  addUserArea,
  getSelectAllProvince
} from '@/api/master/MasterList'
import {
  memberInfo,
  Serverlist,
  Serverinsert,
  Serverdelete,
  MemberInfoget,
  memberList,
  InfoUpdate,
  infodisable,
  infopen,
  infodelete,
  listContract,
  updateContract,
  updateMain,
  MemberServer,
  Pointget,
  memberOpen,
  memberDisable,
  memberDelete,
  selectServeArea,
  memberInfoSelectOrderNum,
  batchDelete
} from '@/api/master/TeamManagement'
import NewLeagueMembers from './NewLeagueMembers.vue'
import MemberService from './memberService.vue'
import { getDictMap } from '../../../utils/dict'
import pick from 'lodash.pick'
import _ from 'lodash'

const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" style="width: 210px" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String
  },
  data() {
    return {
      areaList: [],
      value: this.text,
      editable: false
    }
  },
  methods: {
    handleChange(e) {
      console.log('handleChange')
      const value = e.target.value
      this.value = value
    },
    check() {
      console.log('check')
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      console.log('edit')
      this.editable = true
    }
  }
}

const EditableCell3 = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" style="width: 210px" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String
  },
  data() {
    return {
      value: this.text,
      editable: false
    }
  },
  methods: {
    handleChange(e) {
      console.log('handleChange')
      const value = e.target.value
      this.value = value
    },
    check() {
      console.log('check')
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      console.log('edit')
      this.editable = true
    }
  }
}

//合同有效期
const EditableCell2 = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
        <a-range-picker
            class="editable-cell-icon-check"
            style="width:210px"
            v-model="dataTime"
            @change="ChangeTime"
              :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
            />
        <a-input  @pressEnter="check" style="width: 210px;display: none" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
            style="width:210px"
          />

        </div>
        <div v-else class="editable-cell-text-wrapper">
            <span v-if="start === null||end === null"></span>
            <span v-else>{{ start + ' - ' + end || ' ' }}</span>
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    start: String,
    end: String
  },
  data() {
    return {
      value: this.text,
      editable: false,
      dataTime: ''
      // show:true,
    }
  },
  methods: {
    ChangeTime(dates, dateStrings) {
      this.start = dateStrings[0]
      this.end = dateStrings[1]
      if (this.start != '' && this.end != '') {
        this.value = [dateStrings[0], dateStrings[1]]
        this.dataTime = [moment(dateStrings[0]), moment(dateStrings[1])]
      }
    },
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
    }
  }
}

export default {
  name: 'TeamDetails',
  components: {
    STable,
    NewLeagueMembers,
    EditableCell,
    EditableCell2,
    Tomap,
    EditableCell3,
    MemberService,
    pdf
  },
  data() {
    return {
      areaList: [],
      checkAll: false,
      warnShow: false,
      addEnable: checkPermission('master:teamList:memberList:add'),
      editEnable: checkPermission('master:teamList:memberList:edit'),
      deleteEnabel: checkPermission('master:teamList:memberList:delete'),
      deitEnabel: checkPermission('master:teamList:contract:deit'),
      contractDelete: checkPermission('master:teamList:contract:delete'),
      contractSelect: checkPermission('master:teamList:contract:select'),
      memberListDetail: checkPermission('master:teamList:memberList:detail'),
      fileList1: [],
      teamId: '',
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/uploadContract?type=TeamContract&id=' + this.teamId,
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: 'pdf', // 文件类型
      src: '', // pdf文件地址
      visible5: false, //文件查看
      ScoreArr: {
        firstFicScore: '',
        firstFicTransparency: '',
        secondFicScore: '',
        secondFicTransparency: ''
      },
      EchartsData: [], //雷达图数据
      contractData: [],
      checkboxs: true,
      columns3: [
        {
          title: '合同文件',
          dataIndex: 'disable',
          scopedSlots: { customRender: 'action2' }
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '合同名称',
          dataIndex: 'contractName',
          scopedSlots: { customRender: 'name3' }
        },
        {
          title: '合同有效期',
          dataIndex: 'contractStartTime',
          scopedSlots: { customRender: 'name2' }
        },
        {
          title: '是否主合同',
          dataIndex: 'isMainContract',
          scopedSlots: { customRender: 'action3' }
        }
      ],
      teamShow: '',
      addd: [],
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      coverageData: [],
      columns4: [
        {
          title: '省',
          dataIndex: 'province',
          align: 'center'
        },
        {
          title: '市',
          dataIndex: 'city',
          align: 'center'
        },
        {
          title: '区',
          dataIndex: 'area',
          align: 'center'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   width:'20px',
        //   scopedSlots: { customRender: 'action'},
        // },
      ],
      loadData: parameter => {
        this.queryParam.teamId = this.teamId
        return memberList(Object.assign(parameter, this.queryParam))
      },
      columns2: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作栏',
          width: '20px',
          dataIndex: 'disable',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '团员姓名',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'phone',
          align: 'center'
        },
        {
          title: '标签',
          dataIndex: 'label',
          align: 'center'
        },
        {
          title: '团队等级',
          dataIndex: 'level',
          align: 'center'
        },
        {
          title: '得分',
          dataIndex: 'score',
          align: 'center'
        },
        {
          title: '接单方式',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '服务类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '接单量',
          dataIndex: 'orderNum',
          align: 'center'
        },
        {
          title: '未销单量',
          dataIndex: 'noSaleOrder',
          align: 'center'
        },
        {
          title: '近30天投诉率',
          dataIndex: 'complaintRateRecent',
          align: 'center'
        },
        {
          title: '合同文件',
          dataIndex: 'hasContract',
          align: 'center'
        },
        {
          title: '合同有效期',
          dataIndex: 'contractDuration',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center'
        }
      ],
      pagination2: true,
      loading: false,
      pagination: false,
      queryParam2: {},
      columns: [
        {
          title: '接单量',
          dataIndex: 'OrderNum',
          align: 'center'
        },
        {
          title: '未销单',
          dataIndex: 'noOrder',
          align: 'center'
        },
        {
          title: '近30天投诉率',
          dataIndex: 'complaint',
          align: 'center'
        }
      ],
      tabeldata: [],
      radarData: [],
      installTabs: [],
      show: true,
      data4: [],
      data5: [],
      cdata: [],
      data1: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      restaurantTypes1: [],
      visible: false,
      visible3: false,
      visible4: false,
      confirmLoading: false,
      record: '',
      queryParam: {},
      installType: [],
      sdata: [],
      areaArray2: [],
      userAreaIds: [],
      selectedRowKeys: [],
      userAreaIds2: '',
      userAreaIds3: ''
      // form:this.$form.createForm(this),
    }
  },
  // destroyed () {
  //   this.$nextTick(()=>{
  //     document.body.removeEventListener('keyup', e => {})
  //   })
  // },
  async created() {
    // this.$nextTick(()=>{
    //   document.body.addEventListener('keyup', e => {
    //     if (e.keyCode == 13) {
    //       this.$refs.table4.refresh(true)
    //     }
    //   })
    // })
    //服务类别
    this.restaurantOperTypeMap1 = await getDictMap('install_type')
    this.restaurantOperTypeMap1.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes1.push({ code: key, label: value })
    })
    // 标签
    selectALLInstallLabel().then(res => {
      this.data5 = res.data
    })
    selectInstallTypeAndLabel().then(res => {
      this.data4 = res.data
    })
  },

  computed: {
    // rowSelection() {
    //   return {
    //     onChange: (selectedRowKeys, selectedRows) => {
    //       console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows.teamServerId);
    //       // this.userAreaIds = selectedRowKeys
    //       console.log(selectedRows.teamServerId)
    //       // for(let i=selectedRows.length;i>=selectedRows.length;i--){
    //       //   this.userAreaIds = selectedRows[i].teamServerId
    //       // }
    //       // this.userAreaIds = selectedRows.teamServerId
    //       this.userAreaIds2 = selectedRows
    //       this.userAreaIds3= selectedRowKeys
    //     },
    //     getCheckboxProps: record => ({
    //       props: {
    //         disabled: record.aduitStatus == '', // Column configuration not to be checked
    //         aduitStatus: record.aduitStatus,
    //       },
    //     }),
    //   };
    //
    //   // console.log("record", record)
    // },
  },

  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
      this.userAreaIds2 = selectedRows
      this.userAreaIds3 = selectedRowKeys
    },
    handleClose() {
      this.$emit('ok')
    },
    onChange4(a) {
      console.log('res', a)
      this.checkAll = !this.checkAll
      if (this.checkAll == true) {
        this.$nextTick(() => {
          this.form2.setFieldsValue({
            areaList: this.areaArray2
          })
        })
      } else {
        this.form2.setFieldsValue({
          areaList: []
        })
      }
    },

    onChange(checkedValues) {
      // console.log('checked = ', checkedValues);
      if (checkedValues.length == this.areaArray2.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
      this.$nextTick(() => {
        this.form2.setFieldsValue({
          areaList: checkedValues
        })
      })
    },

    resetDate() {
      this.queryParam = {}
      this.queryParam2 = {}
    },
    onChange1(a, b) {
      this.queryParam.startTime = b[0]
      this.queryParam.endTime = b[1]
      console.log(b)
    },
    //下载
    delByIds(value) {
      window.open(
        process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          value.contractAddress +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      )
    },
    beforeUpload(file) {
      let houzhui = file.name.split('.')
      const isJpgOrPng =
        houzhui[1] == 'doc' ||
        houzhui[1] == 'docx' ||
        houzhui[1] == 'xls' ||
        houzhui[1] == 'ppt' ||
        houzhui[1] == 'pptx' ||
        houzhui[1] == 'xlsx' ||
        houzhui[1] == 'pdf'
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        return false
      } else {
      }
    },
    //上传
    uploadChange(info) {
      this.fileList1 = info.fileList
      let that = this
      if (info.file.status != 'uploading') {
      }
      if (info.file.status === 'done') {
        that.fileList1 = []
        that.$message.success(`上传成功`)
        that.ContractData()
      } else if (info.file.status === 'error') {
        this.$message.error(`上传失败`)
        this.fileList1 = []
      }
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--
        // console.log(this.currentPage)
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
        // console.log(this.currentPage)
      }
    },

    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    //查看
    delsee(contractAddress) {
      this.src =
        process.env.VUE_APP_API_BASE_URL +
        '/dfs/download?fileName=' +
        contractAddress +
        '&token=' +
        Vue.ls.get(ACCESS_TOKEN)
      this.visible5 = true
    },
    onCellChange3(record, dataIndex, value) {
      //合同名称
      console.log(record, dataIndex, value)
      updateContract({
        teamId: this.teamId,
        contractId: record.contractId,
        contractAddress: record.contractAddress,
        contractName: value,
        contractNo: record.contractNo,
        contractStartTime: record.contractStartTime,
        contractEndTime: record.contractEndTime
      }).then(res => {
        console.log(res)
        this.ContractData()
      })
    },
    onCellChange2(record, dataIndex, value) {
      //合同有效期
      updateContract({
        teamId: this.teamId,
        contractId: record.contractId,
        contractAddress: record.contractAddress,
        contractName: record.contractName,
        contractNo: record.contractNo,
        contractStartTime: value[0],
        contractEndTime: value[1]
      }).then(res => {
        this.ContractData()
      })
    },
    onCellChange(record, dataIndex, value) {
      //合同編號
      updateContract({
        teamId: this.teamId,
        contractId: record.contractId,
        contractAddress: record.contractAddress,
        contractName: record.contractName,
        contractNo: value,
        contractStartTime: record.contractStartTime,
        contractEndTime: record.contractEndTime
      }).then(res => {
        this.ContractData()
      })
    },
    handleCheck2(values) {
      console.log(values)
    },
    checkChange(value) {
      if (value.isMainContract == 0) {
        updateMain({
          contractId: value.contractId,
          isMainContract: 1,
          teamId: this.teamId
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('已取消主合同')
            this.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        updateMain({
          contractId: value.contractId,
          isMainContract: 0,
          teamId: this.teamId
        }).then(res => {
          if (res.code === 0) {
            if (res.data == 9) {
              this.$message.success('只能设置一个主合同')
            } else {
              this.$message.success('已设为主合同')
            }
            this.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    showState(value) {
      let teamContractId = value.contractId
      let postData = this.qs.stringify({ teamContractId })
      let that = this
      if (value.disable == 1) {
        infopen(postData).then(res => {
          if (res.code === 0) {
            this.$message.success('启用成功')
            this.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (value.disable == 0) {
        infodisable(postData).then(res => {
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    showState2(value) {
      //团员列表禁用启用
      console.log(value, '团员列表禁用启用')
      let memberId = value.memberId
      let postData = this.qs.stringify({ memberId })
      let that = this
      if (value.black == 1) {
        memberOpen(postData).then(res => {
          if (res.code === 0) {
            this.$message.success('启用成功')
            this.$refs.table4.refresh(true)
            // that.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (value.black == 0) {
        memberDisable(postData).then(res => {
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.$refs.table4.refresh(true)
            // that.ContractData()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    delaction2(val) {
      //团员列表删除
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          let memberId = val.memberId
          let postData = that.qs.stringify({ memberId })
          console.log('团员列表删除')
          memberDelete(postData).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.$refs.table4.refresh(true)
            } else {
              that.$message.error(res.msg)
            }
          })
        }
      })
    },
    delaction(val) {
      //团队合同删除
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          let teamContractId = val.contractId
          let postData = that.qs.stringify({ teamContractId })
          infodelete(postData).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.ContractData()
            } else {
              that.$message.error(res.msg)
            }
          })
        }
      })
    },
    getInitalValue(installType) {
      // console.log(installType)
      // console.log(this.installType)
      for (var item of this.installType) {
        if (item.installType == installType) {
          return item.masterLabelList
        }
      }
    },
    getClose() {
      this.visible = false
      this.$emit('ok')
    },
    haveProvince02(value) {
      // console.log(value)
      this.checkAll = false
      this.warnShow = false
      this.form2.setFieldsValue({ city: undefined, areaList: [] })
      getelectCityName({ provinceCode: value }).then(res => {
        // console.log(res)
        this.cdata = res.rows
      })
    },
    haveProvince03(value) {
      //团队服务区域 区
      this.areaArray2 = []
      this.sdata = []
      selectServeArea({
        cityCode: value,
        teamId: this.teamId
      }).then(res => {
        this.sdata = res.rows
        for (let i = 0; i < res.rows.length; i++) {
          this.areaArray2.push(res.rows[i].areaCode)
        }
      })
      this.checkAll = false
      this.warnShow = false
      this.form2.setFieldsValue({ areaList: [] })
    },
    //团员下的服务区域
    ServiceArea(reacd) {
      this.$refs.modal2.add(reacd)
      this.sdata = []
      this.checkAll = false
    },
    //添加服务区域
    handleSubmit02() {
      this.form2.validateFields((err, values) => {
        if (!err) {
          values.teamId = this.teamId
          if (values.hasOwnProperty('areaList')) {
            this.warnShow = false
            Serverinsert(values).then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.visible4 = false
                Serverlist(this.teamId).then(res => {
                  this.coverageData = res.rows
                })
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.warnShow = true
          }
        }
      })
    },
    //服务区域新增
    addItem1() {
      this.form2.setFieldsValue({
        areaArray: []
      })
      this.form2.resetFields()
      getSelectAllProvince().then(res => {
        this.data1 = res.rows
      })
      this.sdata = []
      this.checkAll = false
      this.visible4 = true
      this.warnShow = false
    },
    // 服务区删除
    delectCoverage() {
      for (let i = 0; i < this.userAreaIds2.length; i++) {
        this.userAreaIds.push(this.userAreaIds2[i].teamServerId)
      }
      // let teamServerId=id
      let that = this

      this.$confirm({
        title: '删除',
        content: '您确定将本条数据删除吗？',
        okType: 'danger',
        onOk() {
          // let teamServerIds= that.qs.stringify({teamServerId})
          batchDelete(that.userAreaIds).then(res => {
            if (res.code === 0) {
              that.userAreaIds2 = []
              that.userAreaIds = []
              that.userAreaIds3 = []
              Serverlist(that.teamId).then(res => {
                that.coverageData = res.rows
              })

              that.$message.success('删除成功')
            } else {
              that.$message.error(res.msg)
            }
          })
        }
      })
    },
    handleClose1() {
      this.visible3 = false
    },
    handleClose2() {
      this.visible4 = false
    },
    handleClose3() {
      this.visible5 = false
    },
    // 服务区域
    coverage() {
      this.visible3 = true
      Serverlist(this.teamId).then(res => {
        console.log(res.rows, 'serverlist')
        this.coverageData = res.rows
      })
    },
    // 服务类别
    handleCheck11(values) {
      this.installTabs = []
      let that = this
      let arr = this.restaurantTypes1
      for (var j = 0; j < values.length; j++) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].code == values[j]) {
            let isList = {}
            isList.code = arr[i].code
            isList.label = arr[i].label
            this.installTabs.push(isList)
          }
        }
      }
      this.$nextTick(() => {
        if (this.installTabs.length > 0) {
          this.$refs['tabPane'].activeKey = this.installTabs[this.installTabs.length - 1].code
        }
      })
    },
    callback2(key) {
      this.tabeldata = []
      console.log(key)
      memberInfoSelectOrderNum({
        installType: key,
        teamId: this.teamId
      }).then(res => {
        this.tabeldata.push(res.data)
      })
      this.$nextTick(() => {
        this.$refs['tabPane'].activeKey = key
      })
      for (let m = 0; m < this.EchartsData.length; m++) {
        if (this.EchartsData[m].installType == key) {
          this.initCharts(this.EchartsData[m])
        }
      }
    },
    handleCheck12(values) {
      console.log(values)
    },
    Tomap() {
      //电子围栏按钮
      Pointget(this.teamId).then(res => {
        this.$refs.tomaps.add(res.data, 0)
      })
    },
    handleChange6(value) {
      if (value.indexOf('0') == -1) {
        this.show = false
      } else {
        this.show = true
      }
    },
    ContractData() {
      listContract(this.teamId).then(res => {
        for (var i = 0; i < res.rows.length; i++) {
          if (res.rows.contractStartTime == null) {
            // res.rows[i].contractStartTime=""
            // res.rows[i].contractEndTime=""
          }
        }

        this.contractData = res.rows
      })
    },
    add(id, record, code) {
      //code 0查看 1编辑
      if (code == 1) {
        this.teamShow = false
      } else {
        this.teamShow = true
      }

      this.teamId = id
      this.uploadUrlb = process.env.VUE_APP_API_BASE_URL + '/dfs/uploadContract?type=TeamContract&id=' + this.teamId
      this.form.resetFields()
      this.tabeldata = []
      this.queryParam = {}
      this.addd = []
      this.visible = true
      this.contractData = []
      let that = this
      this.ContractData()
      MemberInfoget(this.teamId).then(res => {
        //接单情况
        memberInfoSelectOrderNum({
          installType: res.data.teamInstallList[res.data.teamInstallList.length - 1].installType,
          teamId: this.teamId
        }).then(res => {
          this.tabeldata.push(res.data)
        })

        this.EchartsData = res.data.teamInstallList
        that.installType = res.data.teamInstallList
        var listarr = []
        for (let k = 0; k < that.installType.length; k++) {
          for (let s = 0; s < that.installType[k].masterLabelList.length; s++) {
            listarr.push({
              code: k,
              installType: that.installType[k].masterLabelList[s].installLabel
            })
          }
        }
        for (let p = 0; p < that.installType.length; p++) {
          that.installType[p].masterLabelList = []
          for (let v = 0; v < listarr.length; v++) {
            if (p == listarr[v].code) {
              that.installType[p].masterLabelList.push(listarr[v].installType)
            }
          }
        }
        res.data.teamInstallList = that.installType
        if (res.data.openOrder.indexOf('0') == -1) {
          this.show = false
        } else {
          this.show = true
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(res.data, 'abilityScore', 'teamName', 'openOrder', 'installType'))
        })
        //服务类别
        for (var item of res.data.teamInstallList) {
          this.addd.push(item.installType)
        }
        // console.log(this.addd,'服务数据')
        let strArr = []
        for (let m = 0; m < this.EchartsData.length; m++) {
          if (this.EchartsData[m].installType == this.addd[0]) {
            strArr = this.EchartsData[m]
          }
        }
        that.$nextTick(() => {
          that.initCharts(strArr)
        })
        this.handleCheck11(this.addd)
      })
      that.$nextTick(() => {
        that.$refs.table4.refresh(true)
      })
    },
    handleSee(record) {
      //0查看
      this.$refs.modal.Edit(record.memberId, 0, record.userId, record)
    },
    handleEdit(record) {
      //1编辑
      // console.log(record,'编辑')
      this.$refs.modal.Edit(record.memberId, 1, record.userId, record)
    },
    handleadd() {
      //2新增
      this.$refs.modal.add(this.teamId, 2)
    },
    handSubmit(e) {
      e.preventDefault()
      this.checkAll = false
      let tempInstalTypes = []
      this.form.validateFields((err, values) => {
        values.areaId = values.areaArray
        if (!err) {
          for (let installTypeIndex in values['installType']['installType']) {
            let installType = values['installType']['installType'][installTypeIndex]

            for (let val in values) {
              const index = val.indexOf('$' + installType)
              if (index !== -1) {
                const tempValName = val.substr(0, index)
                let obj = {}
                obj['installType'] = installType
                obj['masterLabelList'] = values[val]
                tempInstalTypes.push(obj)
                //values['installType']['installType'][installTypeIndex][tempValName] = values[val]
                delete values[val]
              }
            }
          }

          delete values.abilityScore
          delete values.installType
          console.log(tempInstalTypes, '提交数据')
          for (var i = 0; i < tempInstalTypes.length; i++) {
            tempInstalTypes[i].installLabelList = tempInstalTypes[i].masterLabelList
            delete tempInstalTypes[i].masterLabelList
          }
          values.installTypeDtosList = tempInstalTypes
          values.teamId = this.teamId
          values.divideOrder = values.openOrder
          delete values.openOrder

          InfoUpdate(values).then(res => {
            if (res.code === 0) {
              this.$message.success('提交成功')
              this.visible = false
              this.$emit('ok')
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    handleOk() {
      this.$refs.table4.refresh(true)
    },
    initCharts(data) {
      this.form.setFieldsValue({
        abilityScore: data.masterAbilityList[0].abilityScore
      })
      let that = this
      let myChart = this.$echarts.init(this.$refs.chart)
      let dateArr = []
      let NameArr = []
      for (var k = 1; k < data.masterAbilityList.length; k++) {
        dateArr.push(data.masterAbilityList[k].abilityScore)
        NameArr.push({
          value: data.masterAbilityList[k].abilityScore, //能力得分
          abilityName: data.masterAbilityList[k].abilityName, //能力名称
          firstFicScore: data.masterAbilityList[k].firstFicScore, //虚拟得分1
          firstFicTransparency: data.masterAbilityList[k].firstFicTransparency, //虚拟得分透明度1
          secondFicTransparency: data.masterAbilityList[k].secondFicTransparency, //虚拟得分透明度2
          secondFicScore: data.masterAbilityList[k].secondFicScore //虚拟得分2
        })
      }
      let StrinstallType
      if (data.installType == 'SMART_LOCK') {
        StrinstallType = '智能锁'
      } else if (data.installType == 'LAMP') {
        StrinstallType = '灯具'
      } else if (data.installType == 'SOUND') {
        StrinstallType = '音响'
      } else if (data.installType == 'CURTAIN') {
        StrinstallType = '窗帘'
      }
      console.log(StrinstallType)
      // 绘制图表
      myChart.setOption({
        title: {
          text: '服务能力'
        },
        radar: {
          indicator: [
            { name: '安装难度', max: 100 },
            { name: '时效要求', max: 100 },
            { name: '配合度', max: 100 },
            { name: '服务规范', max: 100 },
            { name: '安装规范', max: 100 }
          ],
          triggerEvent: true
        },
        series: [
          {
            name: '服务能力',
            type: 'radar',
            data: [
              {
                value: dateArr,
                name: StrinstallType
              }
            ]
          }
        ]
      })
      var alert = document.getElementById('alert')
      //鼠标事件
      myChart.off('mouseover')
      myChart.on('mouseover', function(params) {
        console.log(StrinstallType)
        console.log(NameArr, '循环数据', params)
        for (let i = 0; i < NameArr.length; i++) {
          if (NameArr[i].abilityName == params.name) {
            console.log('jinru')
            that.$nextTick(() => {
              that.ScoreArr = NameArr[i]
              that.ScoreArr.installType = StrinstallType
            })
          }
        }
        alert.style.left = params.event.offsetX + 20 + 'px'
        alert.style.top = params.event.offsetY + 10 + 'px'
        if (params.event.offsetX > 300) {
          alert.style.left = '300px'
        }
        if (params.event.offsetY > 300) {
          alert.style.top = '300px'
        }
        if (params.event.offsetY > 300 && params.event.offsetX > 300) {
          alert.style.left = '200px'
          alert.style.top = '100px'
        }
        alert.style.display = 'block'
      })
      myChart.on('mouseout', function(params) {
        alert.style.display = 'none'
      })
    }
  }
}
</script>

<style scoped>
#alert {
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}
.ant-row {
  margin-top: 10px;
}
.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
  padding-right: 24px;
}

.editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
  position: absolute;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
}

.editable-cell-icon-check {
  line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
